import { useState } from 'react';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
import './EnterpriseFaq.css';
import { Link } from 'react-router-dom';


const EnterpriseFaq = () => {
  // Expand all panels by default
  const [expanded, setExpanded] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  // Data for each accordion
  const accordionData = [
    {
      title: "Does Rentid offer API access for integrations?",
      content: ["Yes, Rentid provides full API access so you can integrate bookings, fleet management, payments, and more into your internal systems."]
    },
    {
      title: "Can Rentid support large fleets with thousands of vehicles?",
      content: ["Absolutely. Rentid is built to scale with your business and supports fleets of all sizes, including those managing over 1,000 vehicles."]
    },
    {
      title: "What industries use Rentid’s enterprise tools?",
      content: ["Rentid serves a wide range of industries including car rental marketplaces, fleet and mobility operators, dealerships, hospitality, corporate fleets, and more"]
    },
    {
      title: "Is Rentid compatible with third-party software like CRMs or telematics providers?",
      content: ["Yes. Our open API allows seamless integration with CRMs, telematics platforms, ERPs, and other business systems."]
    },
    {
      title: "What level of support do enterprise clients receive?",
      content: ["Enterprise users get access to dedicated technical support, implementation guidance, API documentation, and sandbox environments for testing and development."]
    },
    {
      title: "Can Rentid be used across multiple branches or business units?",
      content: ["Yes. Rentid supports multi-location operations with centralized visibility, allowing you to manage different branches or teams under one account."]
    },
    {
      title: "Are white-labeled solutions available?",
      content: ["Yes, Rentid offers white-label capabilities so you can maintain your own brand while running your operations on Rentid’s infrastructure."]
    },
    {
      title: "How customizable are rental agreements and workflows?",
      content: ["Rental agreements, terms, automations, and fleet rules are all fully customizable to match your internal policies and compliance requirements."]
    },
    {
      title: "Can different team members have different access permissions?",
      content: ["Yes, you can create role-based access so users only see and manage what’s relevant to their role or location."]
    },
    {
      title: "How does Rentid help with compliance and risk management?",
      content: ["Rentid offers built-in tools for ID verification, insurance validation, DriverIQ™ risk scoring, and telematics to support safe, compliant operations."]
    },
    {
      title: "What does onboarding look like for high-volume businesses?",
      content: ["We provide a guided onboarding process, with technical setup support, API integration help, and ongoing guidance to get your business running quickly."]
    },
    {
      title: "Can I automate operations like pricing, scheduling, and renter vetting?",
      content: ["Yes. Rentid’s enterprise tools allow full automation of workflows including pricing, availability, renter verification, and claims processes."]
    },
    {
      title: "Is there custom pricing available for high-volume operators?",
      content: ["Yes. For fleets over 1,000 vehicles, we offer custom pricing and flexible billing plans tailored to your business model."]
    },
    {
      title: "Does Rentid provide access to analytics and reporting?",
      content: ["Yes. You can view real-time dashboards and generate reports on performance, utilization, revenue, and other key metrics."]
    },
    {
      title: "How do I explore Rentid’s enterprise offering further?",
      content: ["To learn more, contact our sales team to discuss your fleet size, integration needs, and how Rentid can support your business goals."]
    },
  ];

 ;


  const handleExpandClick = () => {
    if (isExpanded) {
      // Collapse all and show only the first two
      setExpanded([]);
    } else {
      // Expand all
     // setExpanded(accordionData.map((_, index) => `panel${index}`));
    }
    setIsExpanded(!isExpanded);
  };
  
  

 

  // Toggle accordion panels without collapsing others
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) =>
      isExpanded ? [...prevExpanded, panel] : prevExpanded.filter(p => p !== panel)
    );
  };

  return (
    <section className='supportFaqMain platformFaqMain'>
      <div className='container'>
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="platformFaqHead">
                    <small>Enterprise</small>
                    <h2>Frequently questions</h2>
                </div>
            </div>
        </div>

        <div className="row justify-content-center align-items-center">       
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="supportFaqRight">
                <div className="supportFaqIcon">
                    <div className="row align-items-center">
                    <div className="col-md-4 col-4 faqIcon">
                      <img src="/img/faq.svg" alt="FAQ" className="img-fluid" />
                    </div>
                    <div className="col-md-8 col-8">
                      <p className="d-flex align-items-center justify-content-end m-0"> 
                      <Link onClick={handleExpandClick} className='expandimg expandBtn'>
                      <img
                        src={isExpanded ? "/img/collapse.svg" : "/img/expand-arrow.svg"}
                        alt="Expand arrow"
                        width="24"
                      />
                      {isExpanded ? 'Collapse' : 'Expand'}
                    </Link>
                      </p>
                    </div>
                    </div>
                </div>
                <div className="headSupportFaq">
                  <h2>FAQ</h2>
                </div>
                <div className="supportFaqRight_Inn">
                  {accordionData.map((accordion, index) => (
                    (isExpanded || index < 2) && (
                      <Box key={index} className="boxAccordian">
                        <Accordion className="headingAccordian"
                          expanded={expanded.includes(`panel${index}`)}
                          onChange={handleAccordionChange(`panel${index}`)}
                        >
                        <AccordionSummary
                      expandIcon={
                        expanded.includes(`panel${index}`) ? (
                          <Typography variant="h6">−</Typography>
                        ) : (
                          <Typography variant="h6">+</Typography>
                        )
                      }
                      aria-controls={`panel${index}-content`}
                    >
                      <Typography>{accordion.title}</Typography>
                    </AccordionSummary>

                        </Accordion>
                        {expanded.includes(`panel${index}`) && (
                          <Box className="summaryAccordian">
                            <Typography>{accordion.content}</Typography>
                          </Box>
                        )}
                      </Box>
                    )
                  ))}

                </div>

                <div className="load-more">
                    <a onClick={handleExpandClick}>  {isExpanded ? 'View Less' : 'View More'}  <img className='img-fluid'   src={isExpanded ? "img/load-more-less.png" : "/img/faq-elements.png"}  alt="View More"/></a>                    
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseFaq;
